// @flow
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';

export type AggregatedCommentUpdated = {
  type: 'AGGREGATED_COMMENT_UPDATED',
  payload: {
    data: Object,
  },
};

export function aggregatedCommentUpdated(data: Object): AggregatedCommentUpdated {
  return {
    type: 'AGGREGATED_COMMENT_UPDATED',
    payload: {
      data,
    },
  };
}

type AggregatedCommentLikeToggled = {
  type: 'AGGREGATED_COMMENT_LIKE_TOGGLED',
  payload: {
    data: {
      id: string,
      reaction_by_me: number,
    },
  },
};

export function aggregatedCommentLikeToggled(data: {
  id: string,
  reaction_by_me: number,
}): AggregatedCommentLikeToggled {
  return {
    type: 'AGGREGATED_COMMENT_LIKE_TOGGLED',
    payload: {
      data,
    },
  };
}

export type AggregatedCommentUpdateData = {
  commentId: string,
  tags: string,
  text: string,
};

export function updateAggregatedComment({
  commentId,
  tags,
  text,
}: AggregatedCommentUpdateData): Thunk<void> {
  return (dispatch) => {
    ResourceFactory.create('AggregatedCommentResource', { commentId, tags, text }).callUpdate({
      showError: false,
    });
    return dispatch(aggregatedCommentUpdated({ id: commentId, tags: JSON.parse(tags), text }));
  };
}

export type AggregatedCommentToggleLikeData = {
  aggregatedCommentId: string,
  isLikedByMe: boolean,
};

export function toggleAggregatedCommentLike({
  aggregatedCommentId,
  isLikedByMe,
}: AggregatedCommentToggleLikeData): Thunk<void> {
  return (dispatch) => {
    const resource = ResourceFactory.create('AggregatedCommentLikeResource', {
      aggregatedCommentId,
    });
    !!isLikedByMe
      ? resource.callDelete({ showError: false })
      : resource.callCreate({ showError: false });
    return dispatch(
      aggregatedCommentLikeToggled({
        id: aggregatedCommentId,
        reaction_by_me: isLikedByMe ? 0 : 1,
      }),
    );
  };
}
